import { StaticImageData } from 'next/image'
import Image from 'next/image'
import { useEffect, useRef } from 'react'
import ReactGA from 'react-ga4'

import archidekt from '@/assets/ads/archidekt.png'
import ckBuylist from '@/assets/ads/ckBuylist.jpg'
import crossword from '@/assets/ads/crossword.png'
import cs from '@/assets/ads/cs.png'
import csb from '@/assets/ads/csb.png'
import csHobbit from '@/assets/ads/csHobbit.webp'
import edhrecap from '@/assets/ads/edhrecap.png'
import edhrecPatreon from '@/assets/ads/edhrecPatreon.png'
import edhrecPatreon201 from '@/assets/ads/edhrecPatreon201.png'
import edhrecPatreon202 from '@/assets/ads/edhrecPatreon202.png'
import edhrecPatreon203 from '@/assets/ads/edhrecPatreon203.png'
import gatherersTavernPoster from '@/assets/ads/gatherersTavern/16x9.jpg'
import gatherersTavernBanner from '@/assets/ads/gatherersTavern/728x90.jpg'
import gatherersTavernPosterAtla from '@/assets/ads/gatherersTavern/atla16x9.png'
import gatherersTavernBannerAtla from '@/assets/ads/gatherersTavern/atla728x90.png'
import gatherersTavernPosterAvatar from '@/assets/ads/gatherersTavern/avatar16x9.png'
import gatherersTavernBannerAvatar from '@/assets/ads/gatherersTavern/avatar728x90.png'
import spellifyDark1 from '@/assets/ads/spellifyDark1.png'
import spellifyDark2 from '@/assets/ads/spellifyDark2.png'
import spellifyLight1 from '@/assets/ads/spellifyLight1.png'
import spellifyLight2 from '@/assets/ads/spellifyLight2.png'
import tcgplayerIntl from '@/assets/ads/tcgplayerIntl.png'
import tcgplayerMayhem from '@/assets/ads/tcgplayerMayhem.jpeg'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { useAppSelector } from '@/store/hooks'
import useDirectories from '@/utils/useDirectories'

import styles from './Ad.module.scss'

type AdConfigItem = {
  alt: string
  disableUtm?: boolean
  src: StaticImageData | { lg: StaticImageData; sm: StaticImageData }
  url: string | { lg: string; sm: string }
  urlConfigs?: { src: StaticImageData; subpage: string; url: string }[]
}

const config: { [key: string]: AdConfigItem } = {
  archidekt: { alt: 'Archidekt', src: archidekt, url: 'https://archidekt.com/landing' },
  ckBuylist: {
    alt: 'Get 30% Credit When Selling To Card Kingdom',
    src: ckBuylist,
    url: 'https://www.cardkingdom.com/purchasing/how_to_sell?partner=EDHRECSell&utm_medium=affiliate&utm_campaign=edhrec&partner_args=leaderboard',
  },
  crossword: { alt: 'EDHREC Crossword', src: crossword, url: 'edhrec.com/games/crossword' },
  cs: { alt: 'Cardsphere', src: cs, url: 'cardsphere.com' },
  csb: { alt: 'Commander Spellbook', src: csb, url: 'commanderspellbook.com' },
  csHobbit: { alt: 'Cardsphere', src: csHobbit, url: 'try.cardsphere.com/edhrec-hobbit' },
  edhrecap: { alt: 'EDHRecap', src: edhrecap, url: 'edhrec.com/newsletter' },
  edhrecPatreon: { alt: 'EDHREC Patreon', src: edhrecPatreon, url: 'patreon.com/edhrec' },
  edhrecPatreon201: { alt: 'EDHREC Patreon', src: edhrecPatreon201, url: 'patreon.com/edhrec' },
  edhrecPatreon202: { alt: 'EDHREC Patreon', src: edhrecPatreon202, url: 'patreon.com/edhrec' },
  edhrecPatreon203: { alt: 'EDHREC Patreon', src: edhrecPatreon203, url: 'patreon.com/edhrec' },
  /* heavyPlay: {
    alt: 'Heavy Play',
    src: heavyPlay5Color,
    url: 'heavyplay.com',
    urlConfigs: [
      { src: heavyPlayWhite, subpage: 'w', url: 'https://heavyplay.com/collections/white' },
      { src: heavyPlayBlue, subpage: 'u', url: 'https://heavyplay.com/collections/blue' },
      { src: heavyPlayBlack, subpage: 'b', url: 'https://heavyplay.com/collections/black' },
      { src: heavyPlayRed, subpage: 'r', url: 'https://heavyplay.com/collections/red' },
      { src: heavyPlayGreen, subpage: 'g', url: 'https://heavyplay.com/collections/green' },
      { src: heavyPlayColorless, subpage: 'colorless', url: 'https://heavyplay.com/collections/colorless' },
      { src: heavyPlayAzorius, subpage: 'wu', url: 'https://heavyplay.com/collections/azorius' },
      { src: heavyPlayDimir, subpage: 'ub', url: 'https://heavyplay.com/collections/dimir' },
      { src: heavyPlayRakdos, subpage: 'br', url: 'https://heavyplay.com/collections/rakdos' },
      { src: heavyPlayGruul, subpage: 'rg', url: 'https://heavyplay.com/collections/gruul' },
      { src: heavyPlaySelesnya, subpage: 'gw', url: 'https://heavyplay.com/collections/selesnya' },
      { src: heavyPlayOrzhov, subpage: 'wb', url: 'https://heavyplay.com/collections/orzhov' },
      { src: heavyPlayIzzet, subpage: 'ur', url: 'https://heavyplay.com/collections/izzet' },
      { src: heavyPlayGolgari, subpage: 'bg', url: 'https://heavyplay.com/collections/golgari' },
      { src: heavyPlayBoros, subpage: 'rw', url: 'https://heavyplay.com/collections/boros' },
      { src: heavyPlaySimic, subpage: 'gu', url: 'https://heavyplay.com/collections/simic' },
      { src: heavyPlayEsper, subpage: 'wub', url: 'https://heavyplay.com/collections/esper' },
      { src: heavyPlayGrixis, subpage: 'ubr', url: 'https://heavyplay.com/collections/grixis' },
      { src: heavyPlayJund, subpage: 'brg', url: 'https://heavyplay.com/collections/jund' },
      { src: heavyPlayNaya, subpage: 'rgw', url: 'https://heavyplay.com/collections/naya' },
      { src: heavyPlayBant, subpage: 'gwu', url: 'https://heavyplay.com/collections/bant' },
      { src: heavyPlayAbzan, subpage: 'wbg', url: 'https://heavyplay.com/collections/abzan' },
      { src: heavyPlayJeskai, subpage: 'urw', url: 'https://heavyplay.com/collections/jeskai' },
      { src: heavyPlaySultai, subpage: 'bgu', url: 'https://heavyplay.com/collections/sultai' },
      { src: heavyPlayMardu, subpage: 'rwb', url: 'https://heavyplay.com/collections/mardu' },
      { src: heavyPlayTemur, subpage: 'gur', url: 'https://heavyplay.com/collections/temur' },
      { src: heavyPlay5Color, subpage: 'wubrg', url: 'https://heavyplay.com/collections/wubrg' },
    ],
  }, */
  gatherersTavernBannerAppa: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAvatar,
    url: 'https://www.gathererstavern.com/products/appa-arty-box?variant=51428309303575',
  },
  gatherersTavernBannerAtlaAir: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAtla,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333748503',
  },
  gatherersTavernBannerAtlaEarth: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAtla,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333715735',
  },
  gatherersTavernBannerAtlaFire: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAtla,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333650199',
  },
  gatherersTavernBannerAtlaWater: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAtla,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333682967',
  },
  gatherersTavernBannerBetor: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558223127',
  },
  gatherersTavernBannerMomo: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAvatar,
    url: 'https://www.gathererstavern.com/products/momo-arty-box?variant=51428328505623',
  },
  gatherersTavernBannerNeriv: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558255895',
  },
  gatherersTavernBannerShiko: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558288663',
  },
  gatherersTavernBannerTeval: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558321431',
  },
  gatherersTavernBannerUreni: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558354199',
  },
  gatherersTavernPosterAppa: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAvatar,
    url: 'https://www.gathererstavern.com/products/appa-arty-box?variant=51428309303575',
  },
  gatherersTavernPosterAtlaAir: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAtla,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333748503',
  },
  gatherersTavernPosterAtlaEarth: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAtla,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333715735',
  },
  gatherersTavernPosterAtlaFire: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAtla,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333650199',
  },
  gatherersTavernPosterAtlaWater: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAtla,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333682967',
  },
  gatherersTavernPosterBetor: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395282199',
  },
  gatherersTavernPosterMomo: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAvatar,
    url: 'https://www.gathererstavern.com/products/momo-arty-box?variant=51428328505623',
  },
  gatherersTavernPosterNeriv: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395314967',
  },
  gatherersTavernPosterShiko: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395347735',
  },
  gatherersTavernPosterTeval: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395380503',
  },
  gatherersTavernPosterUreni: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395413271',
  },
  placeholder: {
    alt: 'An entry with lg and sm must exist to satisfy TypeScript',
    src: { lg: archidekt, sm: archidekt },
    url: { lg: '', sm: '' },
  },
  spellifyDark1: {
    alt: 'Spellify',
    src: spellifyDark1,
    url: 'https://edhrec.com/games/spellify?utm_campaign=dark1',
  },
  spellifyDark2: {
    alt: 'Spellify',
    src: spellifyDark2,
    url: 'https://edhrec.com/games/spellify?utm_campaign=dark2',
  },
  spellifyLight1: {
    alt: 'Spellify',
    src: spellifyLight1,
    url: 'https://edhrec.com/games/spellify?utm_campaign=light1',
  },
  spellifyLight2: {
    alt: 'Spellify',
    src: spellifyLight2,
    url: 'https://edhrec.com/games/spellify?utm_campaign=light2',
  },
  tcgplayerIntl: {
    alt: 'TCGPlayer International Shipping',
    src: tcgplayerIntl,
    url: 'https://partner.tcgplayer.com/c/4913290/3841229/21018',
  },
  tcgplayerMayhem: {
    alt: 'TCGPlayer Mayhem',
    src: tcgplayerMayhem,
    url: 'https://partner.tcgplayer.com/c/4913290/3904321/21018',
  },
}

type Props = {
  id: keyof typeof config
  unit: 'leaderboard' | 'midbanner'
}

const Ad = ({ id, unit }: Props) => {
  const displayName = useAppSelector((state) => state.user.displayName)
  const { subpage } = useDirectories()
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    ReactGA.event({
      action: 'Load',
      category: 'Ad',
      label: id as string,
      nonInteraction: true,
    })
    if (displayName) {
      ReactGA.event({
        action: 'Load-LoggedIn',
        category: 'Ad',
        label: id as string,
        nonInteraction: true,
      })
    }

    console.log('inhouse_ad_loaded', id)
    ReactGA.event('inhouse_ad_loaded', {
      id: id as string,
      nonInteraction: true,
      unit: unit as string,
    })
  }, [displayName, id])

  // Track ad impressions when the ad is at least 50% visible for 1 second
  useEffect(() => {
    const container = containerRef.current

    if (!container || typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return
    }

    let impressionTimeout: number | null = null
    let impressionTracked = false

    const clearImpressionTimeout = () => {
      if (impressionTimeout !== null) {
        window.clearTimeout(impressionTimeout)
        impressionTimeout = null
      }
    }

    const trackImpression = () => {
      if (impressionTracked) {
        return
      }

      impressionTracked = true
      impressionTimeout = null
      console.log('inhouse_ad_impression', id)
      ReactGA.event('inhouse_ad_impression', {
        id: id as string,
        nonInteraction: true,
        unit: unit as string,
      })
      observer.disconnect()
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry || impressionTracked) {
          clearImpressionTimeout()
          return
        }

        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (impressionTimeout === null) {
            impressionTimeout = window.setTimeout(trackImpression, 1000)
          }
          return
        }

        clearImpressionTimeout()
      },
      { threshold: [0.5] },
    )

    observer.observe(container)

    return () => {
      clearImpressionTimeout()
      observer.disconnect()
    }
  }, [id])

  if (!Object.keys(config).includes(id as string)) {
    return null
  }

  const { alt, disableUtm, src, url, urlConfigs } = config[id]

  let adContent

  if (urlConfigs && subpage) {
    const subpageAd = urlConfigs.find((urlConfig) => urlConfig.subpage === subpage)
    if (subpageAd) {
      adContent = (
        <OutboundLink url={subpageAd.url} utm_medium='leaderboard'>
          <img alt={alt} className={styles.ad} src={('src' in subpageAd.src && subpageAd.src.src) || ''} />
        </OutboundLink>
      )
    }
  }

  if (!adContent && typeof url === 'string') {
    adContent = (
      <OutboundLink disableUtm={disableUtm} url={url} utm_medium='leaderboard'>
        <img alt={alt} className={styles.ad} src={('src' in src && src.src) || ''} />
      </OutboundLink>
    )
  }

  if (!adContent) {
    const responsiveUrl = url as { lg: string; sm: string }
    const responsiveSrc = src as { lg: StaticImageData; sm: StaticImageData }

    adContent = (
      <>
        <OutboundLink className='d-block d-sm-none' url={responsiveUrl.sm} utm_medium='leaderboard'>
          <Image alt={alt} className={styles.ad} src={responsiveSrc.sm.src || ''} />
        </OutboundLink>
        <OutboundLink className='d-none d-sm-block' url={responsiveUrl.lg} utm_medium='leaderboard'>
          <Image alt={alt} className={styles.ad} src={responsiveSrc.lg.src || ''} />
        </OutboundLink>
      </>
    )
  }

  return <div ref={containerRef}>{adContent}</div>
}

export { config }
export default Ad
